import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Program } from '@playbook-technologies/common-enums';
import { clsx } from 'clsx';
import { GetAllProgramsQuery } from 'generated/graphql';
import { Link } from '@client/router/compat';
import * as styles from './ProgramMenu.css';

type ProgramListItem = NonNullable<
  GetAllProgramsQuery['creator']
>['programs'][number];

type ProgramMenuProps = {
  programs: ProgramListItem[];
  creatorId: number;
  selectedProgramId: number;
};
type ProgramTabLinkProps = {
  program: ProgramListItem;
  creatorId: number;
  isSelected: boolean;
};

const ProgramTabLink = ({
  program,
  creatorId,
  isSelected,
}: ProgramTabLinkProps) => (
  <Link
    to={`/admin/partner/${creatorId}/workouts/published/${program.id}`}
    className={clsx(styles.programTabLink, {
      [styles.programTabLinkSelected]: isSelected,
    })}
    style={isSelected ? { background: `#${program.color}` } : undefined}
  >
    <span className="mr-2">{program.name}</span>
    {!program.isVisible && <FontAwesomeIcon icon={faEyeSlash} />}
    {program.accessType === Program.AccessType.Exclusive.value && ' 👑'}
    {program.isLocked && ' 🔒'}
  </Link>
);

export const ProgramMenu = (props: ProgramMenuProps) => {
  return (
    <section className={styles.programTabMenu}>
      <div className={styles.programTabSelector}>
        {props.programs.map((p) => (
          <ProgramTabLink
            key={p.id}
            program={p}
            creatorId={props.creatorId}
            isSelected={props.selectedProgramId == p.id}
          />
        ))}
      </div>
    </section>
  );
};
